(() => {
  if (window.wvHomeTeaserLoaded || !document.body.classList.contains('template-index')) return;
  window.wvHomeTeaserLoaded = true;
  const selector = '.kl-teaser-TGxxea';
  const sessionKey = 'wv-teaser-TGxxea-dismissed';
  const narrow = window.matchMedia('(max-width: 1647px)');
  const mobile = window.matchMedia('(max-width: 749px)');
  const english = document.documentElement.lang.startsWith('en');
  let dismissed = false;
  let frame = 0;
  let panel;
  let offer;
  let trigger;
  let openedHere = false;
  try { dismissed = sessionStorage.getItem(sessionKey) === 'true'; } catch {}

  const dismiss = () => {
    dismissed = true;
    try { sessionStorage.setItem(sessionKey, 'true'); } catch {}
    if (panel) panel.hidden = true;
    document.querySelectorAll(selector).forEach(element => { element.dataset.wvDismissed = 'true'; element.inert = true; });
  };
  const sync = () => {
    frame = 0;
    const native = document.querySelector(selector);
    const nativeTrigger = native?.querySelector('[role="button"]');
    const container = document.querySelector('.wvr--products > .wvr-container');
    if (dismissed) {
      if (native && native.dataset.wvDismissed !== 'true') {
        native.dataset.wvDismissed = 'true';
        native.inert = true;
      }
      return;
    }
    if (!container || !nativeTrigger) {
      if (panel && !openedHere) panel.hidden = true;
      return;
    }
    const label = nativeTrigger.textContent.replace(/\s+/g, ' ').trim();
    if (!label) return;
    if (!panel?.isConnected) {
      panel = document.createElement('div');
      panel.className = 'wv-home-offer';
      panel.hidden = true;
      const context = document.createElement('span');
      context.className = 'wv-home-offer__context';
      context.textContent = 'Newsletter';
      trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'wv-home-offer__open';
      trigger.setAttribute('aria-haspopup', 'dialog');
      offer = document.createElement('span');
      trigger.append(offer);
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'wv-home-offer__close';
      close.setAttribute('aria-label', english ? 'Dismiss newsletter offer' : 'Newsletter-Angebot ausblenden');
      const icon = document.createElement('span');
      icon.setAttribute('aria-hidden', 'true');
      close.append(icon);
      trigger.addEventListener('click', () => {
        const target = document.querySelector(`${selector} [role="button"]`);
        if (!target) return sync();
        openedHere = true;
        target.click();
      });
      close.addEventListener('click', () => {
        const next = container.querySelector('.wvr-product a[href]');
        document.querySelector(`${selector} .klaviyo-close-form`)?.click();
        dismiss();
        next?.focus({ preventScroll: true });
      });
      panel.append(context, trigger, close);
    }
    const anchor = mobile.matches
      ? container.querySelector('.wvr-product-controls') || container.querySelector('.wvr-products')
      : container.querySelector('.wvr-heading');
    if (anchor && panel.previousElementSibling !== anchor) anchor.after(panel);
    else if (!panel.isConnected) container.append(panel);
    if (offer.textContent !== label) offer.textContent = label;
    if (panel.hidden === narrow.matches) panel.hidden = !narrow.matches;
    if (native.dataset.wvInline !== 'true') native.dataset.wvInline = 'true';
    native.inert = narrow.matches;
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
  document.addEventListener('click', event => {
    if (event.target.closest(`${selector} .klaviyo-close-form`)) dismiss();
  }, true);
  window.addEventListener('klaviyoForms', event => {
    if (event.detail?.formId !== 'TGxxea' || event.detail.type !== 'close' || !openedHere) return;
    openedHere = false;
    schedule();
    const form = document.querySelector(selector)?.parentElement.querySelector('[role="dialog"]');
    const restoreFocus = () => {
      if (form?.isConnected && getComputedStyle(form).display !== 'none') return;
      closing.disconnect();
      requestAnimationFrame(() => {
        if (panel?.isConnected && !panel.hidden) trigger.focus({ preventScroll: true });
        else document.querySelector(`${selector} [role="button"]`)?.focus({ preventScroll: true });
      });
    };
    const closing = new MutationObserver(restoreFocus);
    if (form) closing.observe(form, { attributes: true, attributeFilter: ['style'] });
    restoreFocus();
  });
  narrow.addEventListener('change', schedule);
  mobile.addEventListener('change', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  sync();
})();
